{
  "appName": "Apply For D.I.C., Survivors Pension, Or Accrued Benefits Online",
  "entryFile": "./survivors-benefits-entry.jsx",
  "entryName": "survivors-benefits",
  "rootUrl": "/family-and-caregiver-benefits/survivor-compensation/apply-for-dic-survivors-pension-accrued-benefits-form-21p-534ez",
  "productId": "51601cf6-a6ff-4621-ac50-f12c37e5193e",
  "datadog": {
    "applicationId": "c1a2c89d-024c-438e-abb5-a8889a6cad31",
    "clientToken": "pubc01fb532cc1b359495386b33268bb021",
    "service": "survivors-benefits",
    "toggleName": "survivorsBenefitsBrowserRumSpecific",
    "sessionReplaySampleRate": 20
  }
}
